import { render, staticRenderFns } from "./PermissoesConvenio.vue?vue&type=template&id=d3c9c934&"
import script from "./PermissoesConvenio.vue?vue&type=script&lang=js&"
export * from "./PermissoesConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports